import { Observable } from 'rxjs';
import { User } from '@app/core/domain';

export interface UserStateInterface {
  getUser(): Observable<User>;
  getUserSnapshot(): User;
  isLoading(): Observable<boolean>;
  setLoading(status?: boolean): void;
  setState(user: User): void;
  userHasPlcCard(): Observable<boolean>;
  setUserHasPlcCard(hasPlc: boolean): void;
  userHasMultiplePlcAccounts(): Observable<boolean>;
  setUserHasMultiplePlcAccounts(hasMultipleAccounts: boolean): void;
  userHasMultipleCardGroups(): Observable<boolean>;
  setUserHasMultipleCardGroups(hasMultipleCardGroups: boolean): void;
  setDateOfBirthStatus(status: boolean): void;
  setAgeVerifiedNegative(status: boolean): void;
  hasDateOfBirth(): Observable<boolean>;
  ageVerifiedNegative(): Observable<boolean>;
  hasMarkedMarketingConsent(): Observable<boolean>;
  setMarkedMarketingConsent(marked: boolean): void;
}

export class UserStateBase implements UserStateInterface {
  getUser(): any { }
  getUserSnapshot(): any { }
  isLoading(): any { }
  setLoading(status?: boolean): void { }
  setState(user: User): void { }
  userHasPlcCard(): any { }
  setUserHasPlcCard(hasPlc: boolean): void { }
  setDateOfBirthStatus(status: boolean): void { }
  setAgeVerifiedNegative(status: boolean): void { }
  hasDateOfBirth(): any { }
  ageVerifiedNegative(): any { }
  setUserHasMultipleCardGroups(hasMultipleCardGroups: boolean): void { }
  setUserHasMultiplePlcAccounts(hasMultipleAccounts: boolean): void { }
  userHasMultipleCardGroups(): any { }
  userHasMultiplePlcAccounts(): any { }
  hasMarkedMarketingConsent(): any { }
  setMarkedMarketingConsent(marked: boolean): void { }
}
